<template>
  <div style="padding: 10px">
    <h2>用户使用条款</h2>
    <div>生效时间：【2022-7-14】 更新时间：【2022-7-14】</div>
    <p class="content">
      {{ form.companyName }}（以下简称｢{{
        form.companyAbbreviation
      }}｣）提醒您：在使用本软件前，请您仔细阅并理解本使用规则，本使用规则将构成您与{{
        form.companyAbbreviation
      }}之间具有法律效力的规则。您可以选择不使用本软件，但如果您使用本软件，包括但不限于注册、登录、浏览本软件、从本软件下载或向本软件上传任何材料、数据、内容，以及以其他方式利用本软件，您的上述行为将被视为对本使用规则全部内容的认可。
    </p>
    <p class="content">
      本软件由{{ form.companyAbbreviation }}建设、维护和运营，并由{{
        form.companyAbbreviation
      }}享有单独、完整的所有权及相关权益。
    </p>
    <h3 class="title">总则</h3>
    <p class="content">
      未经{{
        form.companyAbbreviation
      }}事先的书面同意，您不得以复印、复制、上载、及张贴等形式使用本软件及其中的任何内容进行创作及演绎创作其他作品。
    </p>
    <p class="content">
      您仅可为了个人而非商业的目的使用本软件。该许可的条件是：您不得修改本软件上显示的内容，{{
        form.companyAbbreviation
      }}对本软件及其中的所有内容的版权、商标和其他专有权保留完整的所有权，同时您接受该内容随附的任何条款、条件和声明，及本软件中的所有其他规定。如果本软件提供的其他软件或者信息有特殊使用规定，您也将受该特殊规定限制。
    </p>
    <p class="content">
      如果您未遵守本软件上的条款、条件和声明，则授予您的任何权利将自动终止，而无需事先通知，并且您必须立即删除您所拥有或掌握的所有已下载资料副本。除了上述的有限许可权，{{
        form.companyAbbreviation
      }}不授予您关于任何专利、商标、版权或其他专有权的任何明示的或暗含的权利或许可。您不得在任何软件及其他介质中设置任何与本软件内容相关的镜像。
    </p>
    <h3 class="title">免责与赔偿条款</h3>
    <p class="content">
      本软件及其所包含的材料、信息、内容（包括数据、图像、声音、文本以及其他形式的信息）、服务、软件等（以下统称为｢软件信息｣），由{{
        form.companyAbbreviation
      }}或本软件用户提供。本软件信息均以其现有状态提供，{{
        form.companyAbbreviation
      }}对其不作任何担保。
    </p>
    <p class="content">
      本软件及其所包含的信息可能包含技术性错误、漏洞或拼写、排字方面的错误，{{
        form.companyAbbreviation
      }}不保证本软件及其所包含的信息的准确性和完整性，不保证本软件所包含的信息是最新的、适用于所有地区的，也不保证通过本软件展示或传播的任何评论、建议、观点、陈述及其他信息的可靠性。本软件及其所包含的信息的真实性、准确性和完整性、以及是否过期，应由您自行甄别并承担相应风险及责任。{{
        form.companyAbbreviation
      }}可以根据自己的评估，在不进行通知的情况下，随时修改本软件的信息，包括但不限于显示数据、产品、程序、服务或者价格。{{
        form.companyAbbreviation
      }}也不保证任何被告知或报告的问题将由{{
        form.companyAbbreviation
      }}解决，即使{{ form.companyAbbreviation }}选择为了解决某个问题提供信息
    </p>
    <p class="content">
      如果您下载或以其他方式获得本软件的数据、产品信息、软件、程序或服务信息，那么由您自行承担并负责可能产生的任何风险及损失，包括您信息处理系统的任何盈利损失、业务中断、信息、计划或其他数据的丢失。
    </p>
    <p class="content">
      由于您在本软件上提交、发布或传递的任何信息、资料、数据或任何其他内容而产生纠纷，造成任何损失、责任、费用和开支（包括律师费、诉讼费以及一切其他费用）的，由您自行负责，{{
        form.companyAbbreviation
      }}及其相关人员不对此担负任何责任并有权向您追偿由此产生的一切损失。前述情况下，{{
        form.companyAbbreviation
      }}有权透漏您的身份以及关于您的其他信息。
    </p>
    <h3 class="title">在本软件发布信息</h3>
    <p class="content">
      本软件不保证您在此提交的任何信息的保密性,请勿在此提交保密信息。
    </p>
    <p class="content">
      您应对通过本软件所提交的任何信息负责，包括信息的合法性、可靠性、适用性、原创性和版权所有。您不得通过本软件上传、发布任何内容：
      <br />
      <span>
        01. 是秘密的、专有的、欺诈的、诽谤的、淫秽的、侵犯隐私或知识产权的信息；
      </span>
      <br />
      <span>02. 可能构成或者鼓励犯罪行为，甚至违反法律的；</span>
      <br />
      <span>03. 可能包含软件病毒、群发邮件或者任何形式的｢垃圾邮件｣的；</span>
      <br />
      <span>04. 以任何形式干扰本软件其他用户的。</span>
      <br />
      <br />
      {{
        form.companyAbbreviation
      }}有权在不经过事先通知或取得您同意的情况下，自行决定编辑或删除您提交的任何不可取、不适当或违反本使用规则的信息。
      <br />
      <br />
      如果您提交了材料，表示您已确认授权{{
        form.companyAbbreviation
      }}及其关联公司非限制地、非独占地、不可撤销地、永久地、无版权费地、全球地使用、复制、展示、修改、出版及传播该信息或资料。并且，您也授权{{
        form.companyAbbreviation
      }}及其关联公司无限制的、不可撤销的许可，{{
        form.companyAbbreviation
      }}可以商业或非商业目的无偿使用您或代表您向{{
        form.companyAbbreviation
      }}提交的任何想法、观念或技术。
      <br />
    </p>
    <h3 class="title">版权和商标</h3>
    <p class="content">
      本软件（包括软件上的所有内容）的版权由{{
        form.companyAbbreviation
      }}（或特殊声明的原始所有权人）所有，未经{{
        form.companyAbbreviation
      }}或该原始所有权人书面同意，任何人均不可以任何方式（包括但不限于使用电子及机械等方式）对软件内容进行复制、公开、下载、演示、转载及发送。
      软件中相关注册商标以及{{ form.companyAbbreviation }}已经申请的商标为{{
        form.companyAbbreviation
      }}所有。
    </p>
    <h3 class="title">链接</h3>
    <p class="content">
      为了给您提供方便，本软件为您提供了其他软件的链接，这些软件可能有自己的使用规则。为了您的利益，我们建议您先阅读这些软件的使用规则，{{
        form.companyAbbreviation
      }}将不对这些链接软件的内容以及其运行负责，{{
        form.companyAbbreviation
      }}不对您因使用任何链接造成的损失或侵害结果承担法律责任。
    </p>
    <p class="content">
      除了{{
        form.companyAbbreviation
      }}同意的以外，任何其他形式、针对本软件的所有链接必须经{{
        form.companyAbbreviation
      }}书面批准，以获得链接到本软件的许可权，{{
        form.companyAbbreviation
      }}可以随时自主决定终止链接到本软件的许可权。在这种情况下，您应立即移出到本软件的所有链接并停止使用任何{{
        form.companyAbbreviation
      }}商业标识。
    </p>
    <h3 class="title">国际用户</h3>
    <p class="content">
      {{
        form.companyAbbreviation
      }}不保证本软件的信息适用于中国（大陆）之外的其它地点。如果您从中国（大陆）之外的地点访问该软件，则您有责任遵守所有当地法律。
    </p>

    <h3 class="title">更新</h3>
    <p class="content">
      {{
        form.companyAbbreviation
      }}保留单方随时全部或部分修改、更新本规则的权力。任何修改或更新，一经在本软件公布立即生效，您在本规则修改或更新后使用本软件，即构成您对修改或更新后的规则的认可。因此，建议您经常性地阅读本规则。
    </p>
    <h3 class="title">其他</h3>
    <p class="content">
      附加的或不同的条款、条件和声明可能适用于通过本软件提供的特定资料、信息、产品、软件和服务。如有任何冲突，此类附加的或不同的条款、条件和声明将优先于本使用规则适用。请参阅相应的协议或声明。
    </p>
    <p class="content">
      在任何情况下，对本规则的任何部分未执行的，均不视为{{
        form.companyAbbreviation
      }}放弃该使用条款所赋予我们的权利。
    </p>
    <p class="content">
      本使用规则应受中国法律约束，并按中国法律解释。由本使用规则引起的任何纠纷，应当提交{{
        form.companyAbbreviation
      }}所在地有管辖权的人民法院诉讼解决。
    </p>
    <p class="content">
      本使用条款的解释权以及对本软件使用的解释权归于{{
        form.companyAbbreviation
      }}。
    </p>
  </div>
</template>

<script>
  import { getAll } from "@/api/seting";
  export default {
    data() {
      return {
        //系统设置
        form: {},
      };
    },
    created() {},
    mounted() {
      this.getAll();
    },
    methods: {
      getAll() {
        getAll().then((res) => {
          if (res.status) {
            this.form = res.data;
          }
        });
      },
    },
  };
</script>

<style scoped>
  .title {
    text-align: left;
  }
  .content {
    text-align: left;
  }
</style>
